module.exports = __webpack_public_path__ + "img/platform_1.svg";